
export default {
  styleOverrides: {
    root: {
      '& .MuiOutlinedInput-root': {
        backgroundColor: 'var(--color-bg-paper)',
        color: 'var(--color-text-primary)',

        '& fieldset': {
          borderColor: 'var(--color-border)',
        },

        '&:hover fieldset': {
          borderColor: 'var(--color-primary)',
        },

        '&.Mui-focused fieldset': {
          borderColor: 'var(--color-primary)',
          borderWidth: 2,
        },

        '&.Mui-disabled': {
          backgroundColor: 'var(--color-action-disabled-bg)',
          color: 'var(--color-text-disabled)',
        },
      },

      '& .MuiInputLabel-root': {
        color: 'var(--color-text-secondary)',
      },

      '& .MuiInputLabel-root.Mui-focused': {
        color: 'var(--color-primary)',
      },
    },

    paper: {
      backgroundColor: 'var(--color-bg-paper)',
      color: 'var(--color-text-primary)',
      border: '1px solid var(--color-border)',
      marginTop: 4,
    },

    option: {
      padding: '8px 12px',
      transition: 'background-color 0.15s ease',

      '&[aria-selected="true"]': {
        backgroundColor: 'var(--color-action-selected)',
      },

      '&.Mui-focused': {
        backgroundColor: 'var(--color-action-hover)',
      },

      '&:hover': {
        backgroundColor: 'var(--color-action-hover)',
      },
    },

    popupIndicator: {
      color: 'var(--color-text-secondary)',

      '&:hover': {
        color: 'var(--color-primary)',
      },
    },

    clearIndicator: {
      color: 'var(--color-text-muted)',

      '&:hover': {
        color: 'var(--color-error)',
      },
    },

    noOptions: {
      color: 'var(--color-text-muted)',
      padding: '12px',
    },

    loading: {
      color: 'var(--color-text-muted)',
      padding: '12px',
    },
  },
};
